import axios from '../utils/axios';

export default function fetchShowcaseV2PlansCount(adminId, params) {
    return (
        axios.get(`/admin/${adminId}/showcase-v2-plans-count`, { params })
    )
}
